import './UnconfirmModal.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import Error from '../../../../common/Error/Error';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';

// General UnconfirmModal Component
const UnconfirmModal = ({ category, id, movementType, setModalOpen, refreshMovement }) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const unconfirmMovement = () => {
    if (movementType == 'collections' || movementType == 'imports') {
      setLoading(true);
      GoodsIn.unconfirm(category, id)
        .then(() => {
          setLoading(false);
          refreshMovement();
          setModalOpen(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
    if (movementType == 'deliveries' || movementType == 'exports') {
      setLoading(true);
      GoodsOut.unconfirm(category, id)
        .then(() => {
          setLoading(false);
          refreshMovement();
          setModalOpen(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
  };

  return (
    <div className="unconfirm_movement_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">{`Are you sure that you want to unconfirm this ${
        movementType == 'deliveries'
          ? 'delivery'
          : movementType.substring(0, movementType.length - 1)
      }?`}</div>
      <div className="unconfirm_movement_buttons">
        <button className="unconfirm_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={() => unconfirmMovement()}>
          OK
        </button>
      </div>
    </div>
  );
};

UnconfirmModal.propTypes = {
  category: PropTypes.string,
  movementType: PropTypes.string,
  id: PropTypes.number,
  setModalOpen: PropTypes.func,
  refreshMovement: PropTypes.func,
};

export default UnconfirmModal;
